exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3-CzP{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;height:100%;background:#f5f5f5}._3yx4B{font-size:14px;line-height:17px;margin-bottom:7px}._2ZnAI{font-weight:400;padding-top:4px}._3q_pQ{font-weight:400;margin-top:5px;display:inline-block;font-size:14px;color:#000}._1VLp2 small{font-size:70%;font-weight:400}.kn8hp{background-color:#ffeb3b}._3-CzP ._34aet>div{font-size:14px!important;line-height:14px!important;height:24px}._35cTu .microcredits{height:24px}._35cTu .microcredits>div{font-size:10px!important;line-height:10px!important}._35cTu .creditmarket>div:first-child{display:table-row;text-align:right}", ""]);

// exports
exports.locals = {
	"root": "_3-CzP",
	"title": "_3yx4B",
	"similarYear": "_2ZnAI",
	"contractPrice": "_3q_pQ",
	"similarPrice": "_1VLp2",
	"emphasizePrice": "kn8hp",
	"leasing": "_34aet",
	"leasingButton": "_35cTu"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/AdvertCarCard/SimilarLeasingCard/SimilarLeasingCard.css
// module id = 1769
// module chunks = 20 21 23 32 33 38